// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__4_JUN","wrapper":"Loader_wrapper___YNk9","fullScreen":"Loader_fullScreen__cQUz4","loader":"Loader_loader__DN9xi","loaderDI":"Loader_loaderDI__nLLR6"};